export default "curl -X POST {{url}} -H \"api-key: {{apiKey}}\" -H \"speed: {{speed}}\" -H \"voice: {{voice}}\" -d \"{{text}}\"\n"